module.exports = __webpack_public_path__ + "media/images/accountSection__settingsClose-c28f2f004d155ef001b1fe173ffcb368.png";